import {
    VueTyper
} from 'vue-typer'
import {
    ArrowRightIcon,
    ArrowUpIcon,
    ShieldIcon,
    CpuIcon,
    MailIcon,
    MonitorIcon,
    FeatherIcon,
    EyeIcon,
    UserCheckIcon,
    SmartphoneIcon,
    HeartIcon,
    HelpCircleIcon,
    UserIcon,
    PhoneIcon,
    MessageCircleIcon
} from 'vue-feather-icons';
import {
    Carousel,
    Slide
} from 'vue-carousel';
import countTo from 'vue-count-to';
import Vue from "vue";
import router from "../../router";

import Navbar from "@/components/navbar";
import Switcher from "@/components/switcher";
import Footer from "@/components/footer";
import { contactInsert } from "@/services/contactService";

/**
 * Index-classic-saas component
 */
export default {
    data() {
        return {
            playerVars: {
                autoplay: 1
            },
            name: "",
            email: "",
            tel: "",
            message: "",
            modalContact: false,
            textResult: "",
            token: Vue.$cookies.get('user_token') || null,
        }
    },
    components: {
        Navbar,
        Switcher,
        Footer,
        ArrowRightIcon,
        ArrowUpIcon,
        Carousel,
        Slide,
        countTo,
        ShieldIcon,
        CpuIcon,
        MonitorIcon,
        FeatherIcon,
        EyeIcon,
        UserCheckIcon,
        SmartphoneIcon,
        HeartIcon,
        HelpCircleIcon,
        UserIcon,
        PhoneIcon,
        MessageCircleIcon,
        MailIcon,
        'vue-typer': VueTyper,
    },
    methods: {
        goToLogin() {
            router.push({
                path: "/login",
            });
        },
        goToRegister() {
            router.push({
                path: "/register",
            });
        },
        actionContactInsert() {
            // console.log(this.name)
            contactInsert({
                name: this.name,
                email: this.email,
                tel: this.tel,
                message: this.message,
            }).then((data) => {
                this.modalContact = true
                this.textResult = "ส่งข้อความสำเร็จ"
                console.log(data)
            })
                .catch((err) => {
                    this.modalContact = true
                    this.textResult = "ส่งข้อความไม่สำเร็จ"
                    console.log(err);
                });
        },
    }
}
